import axios from "@/utils/axios.js";
import PageOptions from "@/models/PageOptions";

/**
 * Получение списка заявок
 */
function getOrders(params = new PageOptions()) {
  return new Promise((resolve, reject) => {
    axios
        .get("orders", { params })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

function approveOsr(orderId, osrVote, checksum) {
  return new Promise((resolve, reject) => {
    axios
        .patch(`orders/${orderId}/osr-approval`, {
          osr_vote: osrVote,
          checksum,
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

/**
 * Получение заявки
 */
function getOrder(id) {
  return new Promise((resolve, reject) => {
    axios
        .get(`orders/${id}?expand=passengers,points,comments`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

/**
 * Удаление заявки
 */
function deleteOrder(id) {
  return new Promise((resolve, reject) => {
    axios
        .delete(`orders/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

/**
 * Создание заявки
 * @param {Array} passengers
 * @param {Array} points
 * @param {Array} paths
 */
function createOrder(
    parent_id,
    status_id,
    user_id,
    comment,
    points,
    passengers,
    number,
    supervisor_id,
    logistician_id,
    reason_comment,
    paths,
    is_control,
    is_osr_approvable,
) {
  const orderData = {
    parent_id,
    status_id,
    user_id,
    comment,
    supervisor_id,
    logistician_id,
    reason_comment,
    number,
    passengers,
    points,
    paths,
    is_control,
    is_osr_approvable,
  };

  return new Promise((resolve, reject) => {
    axios
        .post("orders", orderData)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

/**
 * Обновление заявки
 * @param {String} id
 * @param {Array} passengers
 * @param {Array} points
 */
function updateOrder(
    id,
    status_id,
    user_id,
    comment,
    points,
    passengers,
    number,
    supervisor_id,
    logistician_id,
    reason_comment,
    deleteTransferList,
    checksum,
    contract_id,
    is_control,
    is_osr_approvable,
) {
  const orderData = {
    status_id,
    user_id,
    supervisor_id,
    logistician_id,
    comment,
    reason_comment,
    number,
    passengers,
    points,
    deletePoints: deleteTransferList,
    checksum,
    contract_id,
    is_control,
    is_osr_approvable,
  };

  return new Promise((resolve, reject) => {
    axios
        .put(`orders/${id}`, orderData)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

/**
 * Отметить заказ просмотренным
 * @param {Number} id
 */
function markOrderAsViewed(id) {
  return new Promise((resolve, reject) => {
    axios
        .post(`orders-viewed/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

/**
 * Отметить заказ непросмотренным
 * @param {Number} id
 */
function markOrderAsUnviewed(id) {
  return new Promise((resolve, reject) => {
    axios
        .post(`orders-unviewed/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

/**
 * Обновление статусов
 * @param {Array} ordersIdWithStatusId
 */
function updateOrders(ordersIdWithStatusId) {
  return new Promise((resolve, reject) => {
    axios
        .patch(`orders`, { data: ordersIdWithStatusId })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}
/**
* Обновление логиста
*/
function updateOrderLogist(ordersIdWithLogistId) {
  return new Promise((resolve, reject) => {
    axios
        .patch(`orders/logistician`, { data: ordersIdWithLogistId })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

/**
 * Обновление статусов
 * @param {String} orderId
 * @param {Array} passengers
 */
function deletePassengersFromOrder(orderId, passengers) {
  return new Promise((resolve, reject) => {
    axios
        .patch(`orders/${orderId}`, { passengers })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

/**
 * Обновление заявки
 * @param {Number} orderId
 * @param {Number} userOrPassengerId
 * @param {FormData} formData
 */
function addTickets(orderId, userOrPassengerId, formData) {
  return new Promise((resolve, reject) => {
    axios
        .post(`orders/${orderId}/${userOrPassengerId}`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

/**
 * Получение отчетов по заявке
 */
function getGeneralReports(params) {
  return new Promise((resolve, reject) => {
    axios
        .get("orders/report/general", {  params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

/**
 * Получение отчетов по заявке
 */
function getGeneralReportsDeparture(params) {
  return new Promise((resolve, reject) => {
    axios
        .get("/orders/report/general-by-start", {  params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

/**
 * Получение отчетов по заявке
 */
function getReports(params) {
  return new Promise((resolve, reject) => {
    axios
        .get("orders/report/order", { params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

/**
 * Получение итории изменения заявок
 */
function getHistory(params = new PageOptions()) {
  return new Promise((resolve, reject) => {
    axios
        .get("histories", { params })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

// Options for order ------------------------------

/**
 * Получение списка транспорта
 */
function getTransports() {
  return new Promise((resolve, reject) => {
    axios
        .get("transports")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

/**
 * Получение списка статусов
 */
function getStatuses() {
  return new Promise((resolve, reject) => {
    axios
        .get("statuses")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

/**
 * Получение списка статей расходов
 */
function getExpenses() {
  return new Promise((resolve, reject) => {
    axios
        .get("expenses")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

/**
 * Получение списка классов обслуживания
 */
function getPriorities() {
  return new Promise((resolve, reject) => {
    axios
        .get("priorities")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

/**
 * Получение списка типов документов
 */
function getDocumentsType() {
  return new Promise((resolve, reject) => {
    axios
        .get("documents")
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

/**
 * Создание комментария к заявке
 */
function createComment(
  comment,
  order_id,
  status_id,
  point_ids = null,
) {
  return new Promise((resolve, reject) => {
    axios
        .post("comments", { comment, order_id, status_id, point_ids: point_ids })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err);
        });
  });
}

function updateComment(commentId, comment) {
  return new Promise((resolve, reject) => {
    axios
      .put(`comments/${commentId}`, { comment })
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

function deleteComment(commentId) {
  return new Promise((resolve, reject) => {
    axios
      .delete(`comments/${commentId}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export {
  getOrder,
  getOrders,
  deleteOrder,
  createOrder,
  updateOrder,
  markOrderAsUnviewed,
  markOrderAsViewed,
  updateOrders,
  updateOrderLogist,
  addTickets,
  getTransports,
  getStatuses,
  getExpenses,
  getPriorities,
  getDocumentsType,
  getHistory,
  getGeneralReports,
  getGeneralReportsDeparture,
  getReports,
  deletePassengersFromOrder,
  createComment,
  updateComment,
  deleteComment,
  approveOsr,
};
